var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "common-table" },
    [
      _c(
        "el-table",
        _vm._b(
          {
            directives: [
              {
                name: "loading",
                rawName: "v-loading",
                value: _vm.loading,
                expression: "loading",
              },
            ],
            attrs: { data: _vm.list, size: "small" },
          },
          "el-table",
          _vm.tableProps,
          false
        ),
        _vm._l(_vm.columns, function (column, index) {
          return _c("el-table-column", {
            key: column.prop || column.type || index,
            attrs: {
              type: column.type,
              prop: column.prop,
              label: column.label,
              width: column.width,
              "min-width": column.minWidth,
              fixed: column.fixed,
              align: column.align,
              "header-align": column.headerAlign,
              "show-overflow-tooltip": column.showOverflowTooltip,
            },
            scopedSlots: _vm._u(
              [
                {
                  key: "default",
                  fn: function (scope) {
                    return [
                      column.slot
                        ? _vm._t(column.slot, null, {
                            row: scope.row,
                            index: scope.$index,
                            column: column,
                          })
                        : _c("span", [
                            _vm._v(
                              _vm._s(
                                _vm.getCellValue(
                                  column,
                                  scope.row,
                                  scope.$index
                                )
                              )
                            ),
                          ]),
                    ]
                  },
                },
              ],
              null,
              true
            ),
          })
        }),
        1
      ),
      _vm._v(" "),
      _vm.showPagination
        ? _c(
            "div",
            { staticClass: "common-table-pagination" },
            [
              _c("el-pagination", {
                attrs: {
                  background: "",
                  "page-sizes": _vm.innerPageSizes,
                  "page-size": _vm.innerPageSize,
                  "current-page": _vm.innerPage,
                  layout: _vm.paginationLayout,
                  total: _vm.innerTotal,
                },
                on: {
                  "size-change": _vm.handleSizeChange,
                  "current-change": _vm.handleCurrentChange,
                },
              }),
            ],
            1
          )
        : _vm._e(),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }